/* My Essenza — lista de desejos (sem app de terceiros). 22/09/2026.

   MODELO DE DADOS
     localStorage["me_wishlist_v1"] = {"v":1,"itens":[{id,h,t,i,u,d}]}
       id = id numérico do produto · h = handle · t = título · i = foto · u = url · d = data

   PORQUÊ localStorage PRIMEIRO: a esmagadora maioria das visitas é anónima. Se a lista só
   existisse do lado do servidor, o coração só funcionaria depois de criar conta — que é
   exactamente o passo que ninguém dá antes de ter uma razão para o dar. Guardar primeiro
   no browser faz o botão responder sempre, sem rede e sem espera.

   PORQUÊ SINCRONIZAR COM O CLIENTE: quem tem sessão iniciada muda de telemóvel para
   computador e quer a lista lá. Com sessão, a lista deste browser junta-se (merge) com a
   guardada na conta e fica igual em todos os aparelhos.

   IDENTIDADE (22/09, wl2): o browser NUNCA diz quem é o cliente. O pedido vai para
   /apps/me-lista na própria loja; a Shopify (App Proxy da app «Essenza Quadros») reencaminha
   para o nosso serviço e junta-lhe `logged_in_customer_id` assinado com HMAC pelo segredo
   da app — que o Liquid não tem nem precisa de ter. Sem sessão a resposta é
   {sessao:false} e a lista fica só aqui. Se o proxy ainda não existir (404), não se volta
   a perguntar durante 6 h. Serviço: integracao/me_lista_desejos.py.

   REMOÇÕES: guardam-se em `rem` {id: ms}. Sem isso, apagar no telemóvel era desfeito pelo
   computador que ainda tinha o produto. Cada item leva `ts` (ms em que foi guardado).
*/
(function () {
  'use strict';

  var CHAVE = 'me_wishlist_v1';
  var MAX = 100;
  var CFG = null;
  var CACHE = null;
  var REM = null;          // {id: ms da remoção}

  var CORACAO =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 20.5s-7.5-4.6-7.5-9.7A4.3 4.3 0 0 1 12 7.6a4.3 4.3 0 0 1 7.5 3.2c0 5.1-7.5 9.7-7.5 9.7Z"' +
    ' stroke-linejoin="round"/></svg>';

  // ------------------------------------------------------------------ config
  function config() {
    if (CFG) return CFG;
    var el = document.getElementById('me-wishlist-config');
    try { CFG = el ? JSON.parse(el.textContent) : {}; } catch (e) { CFG = {}; }
    if (!CFG.t) CFG.t = {};
    if (!CFG.raiz) CFG.raiz = '';
    return CFG;
  }

  // ---------------------------------------------------------------- guardados
  function ler() {
    if (CACHE) return CACHE;
    var bruto = null;
    try { bruto = localStorage.getItem(CHAVE); } catch (e) { /* modo privado */ }
    try {
      var d = bruto ? JSON.parse(bruto) : null;
      CACHE = d && d.itens && d.itens.length ? d.itens : [];
      REM = d && d.rem && typeof d.rem === 'object' ? d.rem : {};
    } catch (e) { CACHE = []; REM = {}; }
    return CACHE;
  }

  function removidos() { ler(); return REM || (REM = {}); }

  function gravar(itens, sincronizar) {
    CACHE = itens.slice(0, MAX);
    var rem = removidos();
    try { localStorage.setItem(CHAVE, JSON.stringify({ v: 1, itens: CACHE, rem: rem })); } catch (e) {}
    pintar();
    if (sincronizar !== false) agendarSync();
    document.dispatchEvent(new CustomEvent('me-wishlist:mudou', { detail: { itens: CACHE } }));
  }

  function tem(id) {
    var l = ler();
    for (var i = 0; i < l.length; i++) if (String(l[i].id) === String(id)) return true;
    return false;
  }

  function alternar(item) {
    var antes = ler();
    var l = antes.filter(function (x) { return String(x.id) !== String(item.id); });
    var rem = removidos();
    if (l.length === antes.length) {
      // o mais recente fica à cabeça — é o que a pessoa acabou de escolher
      item.ts = Date.now();
      delete rem[String(item.id)];
      l = [item].concat(l);
    } else {
      rem[String(item.id)] = Date.now();
    }
    gravar(l);
    return tem(item.id);
  }

  function retirar(id) {
    removidos()[String(id)] = Date.now();
    gravar(ler().filter(function (x) { return String(x.id) !== String(id); }));
  }

  // ------------------------------------------------ sincronização com a conta
  //
  // Um só pedido faz tudo: manda a lista deste browser, o servidor junta-a com a da conta
  // e devolve o resultado, que passa a ser a lista daqui. /apps/me-lista é o App Proxy:
  // quem diz qual é o cliente é a Shopify, com assinatura — nunca este script.
  var PROXY_ANON = 'me_wl_anon';        // sessionStorage: visitante sem sessão (ms)
  var PROXY_FALTA = 'me_wl_sem_proxy';  // localStorage: proxy ainda não configurado (ms)
  var A_SINCRONIZAR = false;
  var DE_NOVO = false;
  var TEMPORIZADOR = null;

  function urlProxy() { return config().proxy || '/apps/me-lista'; }

  function recente(armazem, chave, ms) {
    try {
      var v = parseInt(armazem.getItem(chave) || '0', 10);
      return v && (Date.now() - v) < ms;
    } catch (e) { return false; }
  }

  function marcar(armazem, chave) { try { armazem.setItem(chave, String(Date.now())); } catch (e) {} }

  function agendarSync() {
    if (TEMPORIZADOR) window.clearTimeout(TEMPORIZADOR);
    // quem acabou de mudar a lista não pode ficar à espera do «anónimo» em cache
    try { sessionStorage.removeItem(PROXY_ANON); } catch (e) {}
    TEMPORIZADOR = window.setTimeout(function () { sincronizar(); }, 800);
  }

  function sincronizar(depois) {
    var fim = function () { if (depois) depois(); };
    if (recente(localStorage, PROXY_FALTA, 6 * 3600 * 1000)) { fim(); return; }
    if (recente(sessionStorage, PROXY_ANON, 3 * 60 * 1000)) { fim(); return; }
    if (A_SINCRONIZAR) { DE_NOVO = true; fim(); return; }
    A_SINCRONIZAR = true;
    fetch(urlProxy(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ itens: ler(), removidos: removidos() })
    })
      .then(function (r) {
        if (r.status === 404) { marcar(localStorage, PROXY_FALTA); return null; }
        var tipo = r.headers.get('content-type') || '';
        return r.ok && tipo.indexOf('json') !== -1 ? r.json() : null;
      })
      .then(function (d) {
        if (!d || !d.ok) return;
        if (!d.sessao) { marcar(sessionStorage, PROXY_ANON); return; }
        var antes = JSON.stringify(ler().map(function (x) { return x.id; }));
        REM = d.removidos || {};
        var depois = JSON.stringify((d.itens || []).map(function (x) { return x.id; }));
        gravar(d.itens || [], false);
        if (antes !== depois) pintar();
      })
      .catch(function () {})
      .then(function () {
        A_SINCRONIZAR = false;
        if (DE_NOVO) { DE_NOVO = false; sincronizar(); }
        fim();
      });
  }

  // ---------------------------------------------------- vistos recentemente
  // O Horizon só guarda 4 (localStorage viewedProducts). A homepage mostra até 12, por isso
  // guardamos os nossos: só o id — os cartões vêm frescos da loja (preço e stock do dia).
  var VISTOS = 'me_vistos_v1';
  function registarVisto() {
    try {
      var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      var pid = m && m.product && m.product.id;
      if (!pid || !(m.page && m.page.pageType === 'product')) return;
      var l = JSON.parse(localStorage.getItem(VISTOS) || '[]');
      l = [String(pid)].concat(l.filter(function (x) { return String(x) !== String(pid); })).slice(0, 12);
      localStorage.setItem(VISTOS, JSON.stringify(l));
    } catch (e) {}
  }

  // ------------------------------------------------------------------- pintar
  function pintar() {
    var n = ler().length;
    var botoes = document.querySelectorAll('[data-me-wl]');
    for (var i = 0; i < botoes.length; i++) {
      var b = botoes[i];
      var guardado = tem(b.getAttribute('data-me-wl'));
      b.setAttribute('aria-pressed', guardado ? 'true' : 'false');
      var texto = b.querySelector('.me-wl-botao__texto');
      var rotulo = guardado
        ? (b.getAttribute('data-guardado') || config().t.guardado || '')
        : (b.getAttribute('data-guardar') || config().t.guardar || '');
      if (texto && texto.textContent !== rotulo) texto.textContent = rotulo;
      if (b.getAttribute('aria-label') !== rotulo) {
        b.setAttribute('aria-label', rotulo);
        b.setAttribute('title', rotulo);
      }
    }
    var contadores = document.querySelectorAll('.me-wl-cabecalho__n');
    for (var j = 0; j < contadores.length; j++) {
      if (contadores[j].textContent !== String(n)) contadores[j].textContent = n;
      if (n > 0) contadores[j].removeAttribute('hidden');
      else contadores[j].setAttribute('hidden', '');
    }
  }

  // ------------------------------------------------------- cliques (delegação)
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest ? ev.target.closest('[data-me-wl]') : null;
    if (!b) return;
    ev.preventDefault();
    ev.stopPropagation();          // nos cartões o <a> de sobreposição levava-nos ao produto
    alternar({
      id: b.getAttribute('data-me-wl'),
      h: b.getAttribute('data-handle') || '',
      t: b.getAttribute('data-titulo') || '',
      i: b.getAttribute('data-imagem') || '',
      u: b.getAttribute('data-url') || '',
      d: new Date().toISOString().slice(0, 10)
    });
  }, true);

  // ------------------------------------------------- coração nos cartões da grelha
  function injetarCartoes() {
    var cartoes = document.querySelectorAll('product-card[data-product-id]');
    for (var i = 0; i < cartoes.length; i++) {
      var c = cartoes[i];
      if (c.querySelector('.me-wl-botao--cartao')) continue;
      var id = c.getAttribute('data-product-id');
      if (!id || id === '' ) continue;
      var lig = c.querySelector('.product-card__link');
      if (!lig || !lig.getAttribute('href')) continue;     // cartão de exemplo do editor
      var img = c.querySelector('img');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'me-wl-botao me-wl-botao--cartao';
      b.setAttribute('data-me-wl', id);
      var href = lig.getAttribute('href');
      var mh = href.match(/\/products\/([^/?#]+)/);
      b.setAttribute('data-url', href);
      b.setAttribute('data-handle', mh ? decodeURIComponent(mh[1]) : '');
      b.setAttribute('data-titulo', lig.getAttribute('aria-label') || '');
      b.setAttribute('data-imagem', img ? (img.currentSrc || img.src || '') : '');
      b.setAttribute('data-guardar', config().t.guardar || '');
      b.setAttribute('data-guardado', config().t.guardado || '');
      b.innerHTML = CORACAO;
      c.appendChild(b);
    }
  }

  // ----------------------------------------------------- contador no cabeçalho
  function injetarCabecalho() {
    var zonas = document.querySelectorAll('header-actions');
    for (var i = 0; i < zonas.length; i++) {
      if (zonas[i].querySelector('.me-wl-cabecalho')) continue;
      var a = document.createElement('a');
      a.className = 'header-actions__action me-wl-cabecalho';
      a.href = config().url_lista || '/pages/lista-de-desejos';
      a.setAttribute('aria-label', config().t.cabecalho || 'Lista de desejos');
      a.setAttribute('title', config().t.cabecalho || 'Lista de desejos');
      a.innerHTML = CORACAO + '<span class="me-wl-cabecalho__n" hidden>0</span>';
      zonas[i].insertBefore(a, zonas[i].firstChild);
    }
  }

  // ------------------------------------------------------------ página da lista
  function dinheiro(centimos) {
    var c = config();
    try {
      return new Intl.NumberFormat(c.locale || 'pt-PT',
        { style: 'currency', currency: c.moeda || 'EUR' }).format(centimos / 100);
    } catch (e) { return (centimos / 100).toFixed(2) + ' ' + (c.moeda || 'EUR'); }
  }

  var A_DESENHAR = false;

  function desenharPagina(caixa) {
    if (A_DESENHAR) return;
    A_DESENHAR = true;
    try { desenharMesmo(caixa); } finally { A_DESENHAR = false; }
  }

  function desenharMesmo(caixa) {
    var c = config();
    var itens = ler();
    caixa.innerHTML = '';
    if (!itens.length) {
      var vazio = document.createElement('div');
      vazio.className = 'me-wl-pagina__vazio';
      vazio.innerHTML = '<p></p>';
      vazio.querySelector('p').textContent = caixa.getAttribute('data-vazio') || '';
      var lig = document.createElement('a');
      lig.className = 'button';
      lig.href = c.url_catalogo || (c.raiz + '/collections/all');
      lig.textContent = caixa.getAttribute('data-continuar') || '';
      vazio.appendChild(lig);
      caixa.appendChild(vazio);
      return;
    }
    var ul = document.createElement('ul');
    ul.className = 'me-wl-grelha';
    itens.forEach(function (it) {
      var li = document.createElement('li');
      li.className = 'me-wl-item is-a-carregar';
      li.setAttribute('data-id', it.id);

      var a = document.createElement('a');
      a.className = 'me-wl-item__foto';
      a.href = it.u || (c.raiz + '/products/' + it.h);
      if (it.i) {
        var img = document.createElement('img');
        img.src = it.i; img.alt = it.t || ''; img.loading = 'lazy';
        a.appendChild(img);
      }
      li.appendChild(a);

      var t = document.createElement('a');
      t.className = 'me-wl-item__titulo';
      t.href = a.href;
      t.textContent = it.t || it.h || '';
      li.appendChild(t);

      var p = document.createElement('p');
      p.className = 'me-wl-item__preco';
      p.textContent = ' ';
      li.appendChild(p);

      var acoes = document.createElement('div');
      acoes.className = 'me-wl-item__acoes';
      var carrinho = document.createElement('button');
      carrinho.type = 'button';
      carrinho.className = 'me-wl-carrinho';
      carrinho.textContent = caixa.getAttribute('data-carrinho') || '';
      carrinho.disabled = true;
      var remover = document.createElement('button');
      remover.type = 'button';
      remover.textContent = caixa.getAttribute('data-remover') || '';
      remover.addEventListener('click', function () {
        retirar(it.id);
        desenharPagina(caixa);
      });
      acoes.appendChild(carrinho);
      acoes.appendChild(remover);
      li.appendChild(acoes);
      ul.appendChild(li);

      // preço e disponibilidade FRESCOS da loja: o que foi guardado no browser pode ter
      // meses, e mostrar um preço velho numa lista de desejos é prometer o que não se cumpre
      if (it.h) {
        fetch(c.raiz + '/products/' + encodeURIComponent(it.h) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            li.classList.remove('is-a-carregar');
            if (!d) return;
            p.textContent = dinheiro(d.price);
            if (d.featured_image && !it.i) {
              var im = document.createElement('img');
              im.src = d.featured_image; im.alt = d.title; im.loading = 'lazy';
              a.appendChild(im);
            }
            t.textContent = d.title;
            var v = null;
            for (var k = 0; k < d.variants.length; k++) {
              if (d.variants[k].available) { v = d.variants[k]; break; }
            }
            if (!v) {
              carrinho.textContent = caixa.getAttribute('data-esgotado') || '';
              return;
            }
            carrinho.disabled = false;
            carrinho.addEventListener('click', function () {
              carrinho.disabled = true;
              fetch(c.raiz + '/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
              }).then(function () { window.location.href = c.raiz + '/cart'; })
                .catch(function () { carrinho.disabled = false; });
            });
          })
          .catch(function () { li.classList.remove('is-a-carregar'); });
      } else {
        li.classList.remove('is-a-carregar');
      }
    });
    caixa.appendChild(ul);
  }

  // ------------------------------------------------------------------ arranque
  function falta() {
    var cartoes = document.querySelectorAll('product-card[data-product-id]');
    for (var i = 0; i < cartoes.length; i++) {
      if (!cartoes[i].querySelector('.me-wl-botao--cartao')) return true;
    }
    var zonas = document.querySelectorAll('header-actions');
    for (var j = 0; j < zonas.length; j++) {
      if (!zonas[j].querySelector('.me-wl-cabecalho')) return true;
    }
    return false;
  }

  var pendente = false;
  function arrancar() {
    if (pendente) return;
    pendente = true;
    window.requestAnimationFrame(function () {
      pendente = false;
      injetarCabecalho();
      injetarCartoes();
      pintar();
      var caixa = document.getElementById('me-wl-lista');
      if (caixa && !caixa.hasAttribute('data-feito')) {
        caixa.setAttribute('data-feito', '1');
        desenharPagina(caixa);
        // redesenha quando a lista muda noutro sítio (ex.: a sincronização trouxe itens
        // guardados noutro aparelho). O trinco A_DESENHAR impede o ciclo com gravar().
        document.addEventListener('me-wishlist:mudou', function () { desenharPagina(caixa); });
      }
    });
  }

  function iniciar() {
    arrancar();
    registarVisto();
    // com a conta: um pedido por página (anónimo fica 3 min em cache na sessão, proxy em
    // falta 6 h) — é o que faz a lista aparecer num aparelho novo logo após o login
    window.setTimeout(function () { sincronizar(arrancar); }, 700);
    // o Horizon troca secções e carrega cartões sem recarregar a página
    document.addEventListener('shopify:section:load', arrancar);
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (falta()) arrancar();
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();

  window.meWishlist = { ler: ler, tem: tem, alternar: alternar, pintar: pintar, sincronizar: sincronizar };
})();
